import request from '@/utils/request'
import store from '@/store'
export function albumInfo (query) {
  return request({
    url: '/api/albumInfo',
    method: 'get',
    params: query
  })
}

export function albumSetting (query) {
  query = Object.assign({viewCode: store.getters.viewId}, query)
  return request({
    url: '/api/albumSetting',
    method: 'get',
    params: query
  })
}

export function lookNumber (query) {
  return request({
    url: '/api/lookNumber',
    method: 'get',
    params: query
  })
}